import { Clock } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function ScheduleNode({ id, data, selected }) {
  const summary = data.interval ? `Every ${data.interval} ${data.unit || 'minutes'}` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.triggers}
      icon={Clock}
      label={data.label}
      hasInput={false}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
